import $ from "jquery";

export interface Response {
    isPaid?: boolean;
    linkPayment?: string;
    date?: string;
}

export interface PaymentMethod {
    processPayment(verbale: string, redirect: boolean): JQuery.jqXHR<any>;

    isFinePaid(verbale: string): JQuery.jqXHR<Response>;
}

export class NexyPayment implements PaymentMethod {
    private url: string;
    private checkPaymentUrl: string;

    constructor(url: string, checkPaymenturl: string) {
        this.url = url;
        this.checkPaymentUrl = checkPaymenturl;
    }

    isFinePaid(verbale: string): JQuery.jqXHR<Response> {
        return $.post(this.checkPaymentUrl, {
            IDVerbale: verbale,
        }, "json")
    }

    processPayment(verbale: string, redirect: boolean): JQuery.jqXHR<any> {
        return $.post(this.url, {
            IDVerbale: verbale,
            RedirectPaginaPagamento: redirect,
        }, "json").done((response) => {
            if (response.hasOwnProperty("isPaid") && response.isPaid) {
                console.log("Payment completed.");
                // Additional "paid" logic here
            } else if (response.linkPayment) {
                window.open(response.linkPayment, "_blank");
            }
        }).fail((...args) => {
            console.error("Error processing Nexy payment:", ...args);
        });
    }
}


export class PayPalPayment implements PaymentMethod {
    private url: string;
    private checkPaymentUrl: string;

    constructor(url: string, checkPaymenturl: string) {
        this.url = url;
        this.checkPaymentUrl = checkPaymenturl;
    }

    isFinePaid(verbale: string): JQuery.jqXHR<Response> {
        return $.post(this.checkPaymentUrl, {
            IDVerbale: verbale,
        }, "json")
    }

    processPayment(verbale: string, redirect: boolean): JQuery.jqXHR<any> {
        return $.post('https://payments.myfines.it/', {
            CodiceUnico: verbale,
            VeicoloTargaR: redirect,
            Enter: '+Next+',
        }, "json").done((response: any) => {

        }).fail((...args) => {
            console.error("Error processing Other payment:", ...args);
        });
    }

    processPaymentInNewTab(verbale: string, targa: string): void {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "https://payments.myfines.it/index.php";
        form.target = "_blank"; // opens in new tab

        const inputs = {
            CodiceUnico: verbale,
            VeicoloTargaR: targa,
            Enter: '+Next+'
        };

        for (const [name, value] of Object.entries(inputs)) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form); // clean up
    }
}
